"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var t = require("./extends-fa579b0f.js"),
  e = require("react"),
  n = require("prop-types"),
  r = require("./guid-3b6bee38.js"),
  o = require("./button-aa3e9cf5.js"),
  a = require("./typography-fb2881fe.js"),
  i = require("./taggedTemplateLiteral-97b463ad.js"),
  u = require("styled-components"),
  c = require("polished/lib/helpers/rem"),
  l = require("./styles-df7980c2.js"),
  s = require("./toPropertyKey-ec4a2a72.js"),
  d = require("./_commonjsHelpers-f10b257f.js"),
  p = require("./slicedToArray-a539bf82.js"),
  f = require("lodash/debounce");
function h(t) {
  return t && "object" == _typeof(t) && "default" in t ? t : {
    "default": t
  };
}
var y,
  g,
  m,
  v,
  b,
  w = h(e),
  x = h(n),
  E = h(u),
  L = h(c),
  T = h(f),
  j = /^((?!chrome|android).)*safari/i.test("undefined" != typeof navigator ? navigator.userAgent : ""),
  _ = E["default"].span(y || (y = i._taggedTemplateLiteral(["\n  ", ";\n"])), function (t) {
    var e = t.theme,
      n = t.typographyProps;
    return "\n      position: relative;\n      display: block;\n      height: auto;\n      padding-bottom: ".concat(a.getVerticalRhythmBottomPadding(n.component, n.disableBottomPadding, e.mediumUp(), n.nextElement, e.smallUp(), n.variant), ";\n    ");
  }),
  k = E["default"](a.TypographyComponent)(g || (g = i._taggedTemplateLiteral(["\n  ", ";\n"])), function (t) {
    var e = t.clampedLines,
      n = t.isExpanded;
    return u.css(m || (m = i._taggedTemplateLiteral(["\n    position: relative;\n    height: 100%;\n    padding-bottom: 0; /** hard-code bottom-padding to override incoming typographyProps on Typography element: should always be set in order for #expand-collapse-typography-button to be properly aligned in container */\n    display: ", ";\n    -webkit-line-clamp: ", ";\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    ", "\n  "])), n ? "block" : "-webkit-box", e, !n && j && "\n        * {\n          display: inline;\n        }\n      ");
  }),
  P = E["default"](o.ButtonComponent)(v || (v = i._taggedTemplateLiteral(["\n  ", "\n"])), function (t) {
    var e = t.backgroundVariant,
      n = t.branding,
      r = t.isExpanded,
      o = t.theme,
      a = t.themeType,
      c = l.getSectionBackgroundColor(e, n, o, a);
    return u.css(b || (b = i._taggedTemplateLiteral(["\n      min-height: inherit;\n      font-size: inherit;\n      line-height: inherit;\n      font-style: inherit;\n      letter-spacing: inherit;\n      text-wrap: balance;\n      ", "\n      ", "\n      && {\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    "])), !r && "\n          position: absolute;\n          right: 0;\n          bottom: 0;\n          border-radius: 0;\n          background-color: ".concat(c, ";\n          ::before {\n            content:' ';\n            position: absolute;\n            display: block;\n            top: 0;\n            left: ").concat(L["default"](-50), ";\n            width: ").concat(L["default"](50), ";\n            height: 100%;\n            background: linear-gradient(90deg, transparent, ").concat(c, " 80%);\n          }\n        "), r && "\n          display: inline-block;\n          text-indent: ".concat(L["default"](5), ";\n          float: right;\n        "), c);
  }),
  C = d.createCommonjsModule(function (t) {
    function e(t, e, n, r, o, a, i) {
      try {
        var u = t[a](i),
          c = u.value;
      } catch (t) {
        return void n(t);
      }
      u.done ? e(c) : Promise.resolve(c).then(r, o);
    }
    t.exports = function (t) {
      return function () {
        var n = this,
          r = arguments;
        return new Promise(function (o, a) {
          var i = t.apply(n, r);
          function u(t) {
            e(i, o, a, u, c, "next", t);
          }
          function c(t) {
            e(i, o, a, u, c, "throw", t);
          }
          u(void 0);
        });
      };
    }, t.exports.__esModule = !0, t.exports["default"] = t.exports;
  }),
  O = d.getDefaultExportFromCjs(C);
function q() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */q = function q() {
    return e;
  };
  var t,
    e = {},
    n = Object.prototype,
    r = n.hasOwnProperty,
    o = Object.defineProperty || function (t, e, n) {
      t[e] = n.value;
    },
    a = "function" == typeof Symbol ? Symbol : {},
    i = a.iterator || "@@iterator",
    u = a.asyncIterator || "@@asyncIterator",
    c = a.toStringTag || "@@toStringTag";
  function l(t, e, n) {
    return Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    l({}, "");
  } catch (t) {
    l = function l(t, e, n) {
      return t[e] = n;
    };
  }
  function d(t, e, n, r) {
    var a = e && e.prototype instanceof v ? e : v,
      i = Object.create(a.prototype),
      u = new N(r || []);
    return o(i, "_invoke", {
      value: k(t, n, u)
    }), i;
  }
  function p(t, e, n) {
    try {
      return {
        type: "normal",
        arg: t.call(e, n)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = d;
  var f = "suspendedStart",
    h = "suspendedYield",
    y = "executing",
    g = "completed",
    m = {};
  function v() {}
  function b() {}
  function w() {}
  var x = {};
  l(x, i, function () {
    return this;
  });
  var E = Object.getPrototypeOf,
    L = E && E(E(G([])));
  L && L !== n && r.call(L, i) && (x = L);
  var T = w.prototype = v.prototype = Object.create(x);
  function j(t) {
    ["next", "throw", "return"].forEach(function (e) {
      l(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function _(t, e) {
    function n(o, a, i, u) {
      var c = p(t[o], t, a);
      if ("throw" !== c.type) {
        var l = c.arg,
          d = l.value;
        return d && "object" == s._typeof(d) && r.call(d, "__await") ? e.resolve(d.__await).then(function (t) {
          n("next", t, i, u);
        }, function (t) {
          n("throw", t, i, u);
        }) : e.resolve(d).then(function (t) {
          l.value = t, i(l);
        }, function (t) {
          return n("throw", t, i, u);
        });
      }
      u(c.arg);
    }
    var a;
    o(this, "_invoke", {
      value: function value(t, r) {
        function o() {
          return new e(function (e, o) {
            n(t, r, e, o);
          });
        }
        return a = a ? a.then(o, o) : o();
      }
    });
  }
  function k(e, n, r) {
    var o = f;
    return function (a, i) {
      if (o === y) throw new Error("Generator is already running");
      if (o === g) {
        if ("throw" === a) throw i;
        return {
          value: t,
          done: !0
        };
      }
      for (r.method = a, r.arg = i;;) {
        var u = r.delegate;
        if (u) {
          var c = P(u, r);
          if (c) {
            if (c === m) continue;
            return c;
          }
        }
        if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
          if (o === f) throw o = g, r.arg;
          r.dispatchException(r.arg);
        } else "return" === r.method && r.abrupt("return", r.arg);
        o = y;
        var l = p(e, n, r);
        if ("normal" === l.type) {
          if (o = r.done ? g : h, l.arg === m) continue;
          return {
            value: l.arg,
            done: r.done
          };
        }
        "throw" === l.type && (o = g, r.method = "throw", r.arg = l.arg);
      }
    };
  }
  function P(e, n) {
    var r = n.method,
      o = e.iterator[r];
    if (o === t) return n.delegate = null, "throw" === r && e.iterator["return"] && (n.method = "return", n.arg = t, P(e, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), m;
    var a = p(o, e.iterator, n.arg);
    if ("throw" === a.type) return n.method = "throw", n.arg = a.arg, n.delegate = null, m;
    var i = a.arg;
    return i ? i.done ? (n[e.resultName] = i.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, m) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, m);
  }
  function C(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function O(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function N(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(C, this), this.reset(!0);
  }
  function G(e) {
    if (e || "" === e) {
      var n = e[i];
      if (n) return n.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          a = function n() {
            for (; ++o < e.length;) if (r.call(e, o)) return n.value = e[o], n.done = !1, n;
            return n.value = t, n.done = !0, n;
          };
        return a.next = a;
      }
    }
    throw new TypeError(s._typeof(e) + " is not iterable");
  }
  return b.prototype = w, o(T, "constructor", {
    value: w,
    configurable: !0
  }), o(w, "constructor", {
    value: b,
    configurable: !0
  }), b.displayName = l(w, c, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === b || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, w) : (t.__proto__ = w, l(t, c, "GeneratorFunction")), t.prototype = Object.create(T), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, j(_.prototype), l(_.prototype, u, function () {
    return this;
  }), e.AsyncIterator = _, e.async = function (t, n, r, o, a) {
    void 0 === a && (a = Promise);
    var i = new _(d(t, n, r, o), a);
    return e.isGeneratorFunction(n) ? i : i.next().then(function (t) {
      return t.done ? t.value : i.next();
    });
  }, j(T), l(T, c, "Generator"), l(T, i, function () {
    return this;
  }), l(T, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      n = [];
    for (var r in e) n.push(r);
    return n.reverse(), function t() {
      for (; n.length;) {
        var r = n.pop();
        if (r in e) return t.value = r, t.done = !1, t;
      }
      return t.done = !0, t;
    };
  }, e.values = G, N.prototype = {
    constructor: N,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(O), !e) for (var n in this) "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var n = this;
      function o(r, o) {
        return u.type = "throw", u.arg = e, n.next = r, o && (n.method = "next", n.arg = t), !!o;
      }
      for (var a = this.tryEntries.length - 1; a >= 0; --a) {
        var i = this.tryEntries[a],
          u = i.completion;
        if ("root" === i.tryLoc) return o("end");
        if (i.tryLoc <= this.prev) {
          var c = r.call(i, "catchLoc"),
            l = r.call(i, "finallyLoc");
          if (c && l) {
            if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return o(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
          } else {
            if (!l) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return o(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var o = this.tryEntries[n];
        if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var a = o;
          break;
        }
      }
      a && ("break" === t || "continue" === t) && a.tryLoc <= e && e <= a.finallyLoc && (a = null);
      var i = a ? a.completion : {};
      return i.type = t, i.arg = e, a ? (this.method = "next", this.next = a.finallyLoc, m) : this.complete(i);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), m;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var n = this.tryEntries[e];
        if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), O(n), m;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var n = this.tryEntries[e];
        if (n.tryLoc === t) {
          var r = n.completion;
          if ("throw" === r.type) {
            var o = r.arg;
            O(n);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, n, r) {
      return this.delegate = {
        iterator: G(e),
        resultName: n,
        nextLoc: r
      }, "next" === this.method && (this.arg = t), m;
    }
  }, e;
}
function N(t) {
  return new Promise(function (e) {
    return setTimeout(e, t);
  });
}
var G = function G(n) {
  var o = n.backgroundVariant,
    a = n.branding,
    i = n.buttonContentCollapsed,
    u = n.buttonContentExpanded,
    c = n.buttonProps,
    l = n.children,
    s = n.clampedLines,
    d = n.className,
    f = n.themeType,
    h = n.typographyIsExpanded,
    y = n.typographyProps,
    g = e.useRef(),
    m = function (t, n) {
      var r = e.useState(!1),
        o = p._slicedToArray(r, 2),
        a = o[0],
        i = o[1],
        u = e.useState(n),
        c = p._slicedToArray(u, 2),
        l = c[0],
        s = c[1],
        d = function d() {
          t && null != t.current && i(t.current.scrollHeight !== t.current.clientHeight);
        },
        f = function () {
          var t = O(q().mark(function t() {
            return q().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return s(!l), t.next = 3, N(50);
                case 3:
                  d();
                case 4:
                case "end":
                  return t.stop();
              }
            }, t);
          }));
          return function () {
            return t.apply(this, arguments);
          };
        }();
      return e.useEffect(function () {
        return d(), "undefined" != typeof document ? (window.addEventListener("resize", T["default"](d, 100)), function () {
          window.removeEventListener("resize", T["default"](d, 100));
        }) : function () {};
      }, []), {
        isClamped: a,
        isExpanded: l,
        toggleExpanded: f
      };
    }(g, h),
    v = m.isClamped,
    b = m.isExpanded,
    x = m.toggleExpanded;
  c || (c = {}), c.id || Object.assign(c, {
    id: r.getGuid()
  });
  return w["default"].createElement(_, {
    className: d,
    typographyProps: y
  }, w["default"].createElement(k, t._extends({
    clampedLines: b ? 0 : s,
    disableBottomPadding: !0,
    isExpanded: b,
    ref: g,
    themeType: f
  }, y), l, (!!b || v) && w["default"].createElement(P, t._extends({
    isExpanded: b,
    backgroundVariant: o,
    branding: a
  }, c, {
    onClick: x,
    themeType: f,
    variant: "tertiary"
  }), b ? u : i)));
};
G.propTypes = {
  backgroundVariant: x["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  branding: x["default"].oneOf(["nm", "pcg"]),
  buttonContentCollapsed: x["default"].oneOfType([x["default"].object, x["default"].string]).isRequired,
  buttonContentExpanded: x["default"].oneOfType([x["default"].object, x["default"].string]).isRequired,
  buttonProps: x["default"].shape(o.buttonPropTypes),
  children: x["default"].node.isRequired,
  clampedLines: x["default"].number.isRequired,
  className: x["default"].string,
  themeType: x["default"].oneOf(["lightTheme", "darkTheme"]),
  typographyIsExpanded: x["default"].bool,
  typographyProps: x["default"].shape(a.typographyPropTypes)
}, G.defaultProps = {
  backgroundVariant: "lightA",
  branding: "nm",
  buttonContentCollapsed: "...Read more",
  buttonContentExpanded: "Read less",
  clampedLines: 3,
  themeType: "lightTheme",
  typographyIsExpanded: !1
}, exports.CollapsibleTypographyComponent = G;